@if (row){
  <kpi4me-text-element
    class="form-field-no-padding"
    #textElementRef
    [hideLabel]="true"
    [formControlElement]="formControl"
    [inputType]="'number'"
    [row]="row"
    #tooltip="matTooltip"
    (modelChange)="tooltip.show()"
    [matTooltip]="textElementRef.getErrorMessage().join(', ')"
    [matTooltipDisabled]="formControl.valid"
  />
}
